/* eslint-disable no-return-assign */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Badge, Group } from '@mantine/core';
import { MRT_ColumnDef } from 'mantine-react-table';
import { useMemo } from 'react';
import {
  CustomTable,
  DefaultCell,
  DefaultValue,
} from '../../../../../components/core/CustomTable/CustomTable';
import { EntityTypeType } from '../../../../../models/core/cache.type';
import { EntitySearchResponseType } from '../../../../../models/core/entities.type';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  entityTypeData: EntityTypeType[];
  data: EntitySearchResponseType[];
  confirmActionResult(item: EntitySearchResponseType, action: string, confirmed: boolean): void;
};
export default function DataView(props: Readonly<DataViewProps>) {
  const columns = useMemo<MRT_ColumnDef<EntitySearchResponseType>[]>(() => {
    const buildBadges = (list: string[]) => {
      if ((list || []).length === 0) {
        return '-';
      }
      return (
        <Group>
          {list.map((x) => (
            <Badge key={x} variant="outline" size="sm">
              {props.entityTypeData.find((y) => y.codigoEntidadeTipo === x)?.entidadeTipo}
            </Badge>
          ))}
        </Group>
      );
    };

    return [
      {
        header: 'Escopos',
        id: 'tipos',
        accessorFn: (row) => {
          const matched = props.entityTypeData
            .filter((y) => row.tipos?.toString().split(',').includes(y.codigoEntidadeTipo))
            .map((y) => y.entidadeTipo);
          return matched.length > 0 ? matched.join(',') : (DefaultValue as string);
        },
        Cell: ({ cell }) => buildBadges(cell.row.original.tipos?.toString().split(',')),
        filterFn: (row, id, filterValue) => {
          const tipos = props.entityTypeData.filter((x) =>
            (row.original.tipos as any).includes(x.codigoEntidadeTipo)
          );
          return tipos.some((x) => x.entidadeTipo.toLowerCase().includes(filterValue.toLowerCase()));
        },
      },
      {
        header: 'CNPJ/CPF',
        accessorFn: (row) => row.cnpj ?? row.cpf ?? DefaultValue,
        size: 180,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
        sortingFn: (a, b) => {
          return (a.original.cnpj || a.original.cpf || '').localeCompare(
            b.original.cnpj || b.original.cpf || ''
          );
        },
        filterFn: (row, id, filterValue) => {
          const value = row.original.cnpj || row.original.cpf || '';
          return value.includes(filterValue.toString());
        },
      },
      {
        header: 'Razão Social/Nome',
        accessorFn: (row) => row.razaoSocial ?? row.nome ?? DefaultValue,
        size: 180,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
        sortingFn: (a, b) => {
          return (a.original.razaoSocial || a.original.nome || '').localeCompare(
            b.original.razaoSocial || b.original.nome || ''
          );
        },
        filterFn: (row, id, filterValue) => {
          const value = row.original.razaoSocial || row.original.nome || '';
          return value.toLowerCase().includes(filterValue.toString().tolowerCase());
        },
      },
      {
        header: 'Nome Fantasia',
        accessorFn: (row) => row.nomeFantasia ?? DefaultValue,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
      },
      {
        header: 'Inscrição Estadual',
        id: 'incricaoEstadual',
        accessorFn: (row) => row.incricaoEstadual ?? DefaultValue,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
      },
      {
        header: 'Inscrição Municipal',
        id: 'incricaoMunicipal',
        accessorFn: (row) => row.incricaoMunicipal ?? DefaultValue,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
      },
      {
        header: 'Unidade SINIR',
        id: 'unidadeSinir',
        accessorFn: (row) => row.unidadeSinir ?? DefaultValue,
        Cell: ({ cell, renderedCellValue }) => DefaultCell({ cell, renderedCellValue }),
      },
      {
        header: 'Acesso SINIR?',
        id: 'acessoSinir',
        accessorFn: (row) => (row.acessoSinir ? 'Sim' : 'Não'),
        filterVariant: 'checkbox',
        columnFilterOptions: ['Sim', 'Não'],
        filterFn: (row, id, filterValue) => {
          if (!filterValue?.length) return true;
          const finalFilterValue = filterValue === 'true' ? 'Sim' : 'Não';
          return finalFilterValue === row.getValue(id);
        },
        Cell: ({ cell }) => (
          <Badge variant="outline" color={cell.getValue() === 'Sim' ? 'green' : 'red'} size="sm">
            {cell.getValue<string>()}
          </Badge>
        ),
      },
      {
        header: 'Acesso à Movimentações?',
        id: 'acessoMovimentacoes',
        accessorFn: (row) => (row.acessoMovimentacoes ? 'Sim' : 'Não'),
        filterVariant: 'checkbox',
        columnFilterOptions: ['Sim', 'Não'],
        filterFn: (row, id, filterValue) => {
          if (!filterValue?.length) return true;
          const finalFilterValue = filterValue === 'true' ? 'Sim' : 'Não';
          return finalFilterValue === row.getValue(id);
        },
        Cell: ({ cell }) => (
          <Badge variant="outline" color={cell.getValue() === 'Sim' ? 'green' : 'red'} size="sm">
            {cell.getValue<string>()}
          </Badge>
        ),
      },
      {
        header: 'Encontro de Contas?',
        id: 'aceitaEncontroContas',
        accessorFn: (row) => (row.aceitaEncontroContas ? 'Sim' : 'Não'),
        filterVariant: 'checkbox',
        columnFilterOptions: ['Sim', 'Não'],
        filterFn: (row, id, filterValue) => {
          if (!filterValue?.length) return true;
          const finalFilterValue = filterValue === 'true' ? 'Sim' : 'Não';
          return finalFilterValue === row.getValue(id);
        },
        Cell: ({ cell }) => (
          <Badge variant="outline" color={cell.getValue() === 'Sim' ? 'green' : 'red'} size="sm">
            {cell.getValue<string>()}
          </Badge>
        ),
      },
    ];
  }, [props.entityTypeData]);

  return (
    <CustomTable
      columns={columns}
      data={props.data}
      initialState={{
        columnVisibility: {
          incricaoEstadual: false,
          incricaoMunicipal: false,
          acessoSinir: false,
          acessoMovimentacoes: false,
        },
      }}
      globalFilterFn="contains"
      enableRowActions
      positionActionsColumn="last"
      displayColumnDefOptions={{ 'mrt-row-actions': { size: 130 } }}
      renderRowActions={(renderProps) => (
        <DataViewActions
          entityTypeData={props.entityTypeData}
          item={renderProps.row.original}
          confirmActionResult={props.confirmActionResult}
        />
      )}
    />
  );
}
